module.exports = __webpack_public_path__ + "static/img/liyade2.5c1cfe6e.jpg";